export default __webpack_public_path__ + "static/media/12.d02f7377.pdf";